import { useEffect } from "react";
import { useState } from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import CartonBoxIcon from "src/assets/CartonBox";
import CreditCardIcon from "src/assets/CreditCard";
import UserIcon from "src/assets/User";
import WrenchIcon from "src/assets/Wrench";
import Config from "./Config";
import Customers from "./Customers";
import Orders from "./Orders";
import Products from "./Products";

const menuItems = [
  {
    name: "Setup",
    href: "/app/amazon",
    icon: <WrenchIcon />,
  },
  {
    name: "Orders",
    href: "/app/amazon/orders",
    icon: <CreditCardIcon />,
  },
  {
    name: "Customers",
    href: "/app/amazon/customers",
    icon: <UserIcon />,
  },
  {
    name: "Products",
    href: "/app/amazon/products",
    icon: <CartonBoxIcon />,
  },
];

function Amazon() {
  const [activeVisible, setActiveVisible] = useState(false);
  const [activeTop, setActiveTop] = useState(0);

  useEffect(() => {
    sessionStorage.setItem("cartType", "amazon");
  });

  return (
    <>
      <div
        className="bg-white py-3 dk-shadow-sm"
        style={{
          minWidth: 240,
          borderRight: "1px solid rgba(0, 0, 0, 0.1)",
          zIndex: 9,
          position: "relative",
        }}
      >
        {activeVisible && (
          <div
            className="ease-in-out-back"
            style={{
              width: 8,
              height: "3.25rem",
              position: "absolute",
              right: 0,
              top: activeTop,
              backgroundColor: "#4962df",
            }}
          ></div>
        )}
        {menuItems.map((item, index) => (
          <NavLink
            exact
            to={item.href}
            className="text-decoration-none px-4 py-3 d-block dk-navlink dk-navlink-hover mb-2 ease-in"
            isActive={(match, location) => {
              if (!match) return false;
              setActiveVisible(true);
              setActiveTop(1 + (3.375 + 0.5) * index + "rem");
              return true;
            }}
            style={{
              fontWeight: 500,
              color: "black"
            }}
          >
            <span className="svg-icon-lg svg-baseline mr-3">{item.icon}</span>
            {item.name}
          </NavLink>
        ))}
      </div>
      <div className="w-100 h-100 overflow-auto" style={{ background: "#f6f6f6" }}>
        <Switch>
          <Route exact path="/app/amazon">
            <Config />
          </Route>
          <Route path="/app/amazon/orders">
            <Orders />
          </Route>
          <Route path="/app/amazon/customers">
            <Customers />
          </Route>
          <Route path="/app/amazon/products">
            <Products />
          </Route>
        </Switch>
      </div>
    </>
  );
}

export default Amazon;
